// extracted by mini-css-extract-plugin
module.exports = {"section":"_3xgbVd","shine-lines":"_1L6k9Y"};